module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: _vm.addButtonClass
  }, [_c('button', {
    staticClass: "btn btn-primary glyphicon glyphicon-refresh",
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "value": "Refresh Page"
    },
    on: {
      "click": _vm.refresh
    }
  })]), _vm._v(" "), _c('div', [_c('v-server-table', {
    ref: "triplocationTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Trip Details")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49be6282"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/trip/TripLocationLog.vue
// module id = 2324
// module chunks = 1